/**
 * PeopleHub (Iter 9.39c)
 *
 * The single People entry point. Replaces the old Airtable-only view
 * with three subtabs as the user required:
 *   - Users (existing AirtablePeoplePage - every /me account)
 *   - Organizations (new - linked to users + host dashboards)
 *   - Host Dashboards (new - Kanban/Table/Grid + preview + link-to-org)
 *
 * Nothing else surfaces under /admin/users anymore.
 */
import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Users, Building2, LayoutDashboard } from "lucide-react";
import AirtablePeoplePage from "@/components/admin/PeoplePage/AirtablePeoplePage";
import AdminOrgsListPage from "@/pages/admin/AdminOrgsListPage";
import AdminHostDashboardsPage from "@/pages/admin/AdminHostDashboardsPage";

export default function PeopleHub() {
  const [active, setActive] = useState("users");
  return (
    <div data-testid="people-hub">
      <Tabs value={active} onValueChange={setActive}>
        <div className="px-4 sm:px-6 pt-4">
          <TabsList>
            <TabsTrigger value="users" data-testid="people-tab-users">
              <Users className="w-3.5 h-3.5 mr-1" />Users
            </TabsTrigger>
            <TabsTrigger value="orgs" data-testid="people-tab-orgs">
              <Building2 className="w-3.5 h-3.5 mr-1" />Organizations
            </TabsTrigger>
            <TabsTrigger value="dashboards" data-testid="people-tab-dashboards">
              <LayoutDashboard className="w-3.5 h-3.5 mr-1" />Host Dashboards
            </TabsTrigger>
          </TabsList>
        </div>
        <TabsContent value="users" className="mt-0">
          <AirtablePeoplePage />
        </TabsContent>
        <TabsContent value="orgs" className="mt-0">
          <AdminOrgsListPage />
        </TabsContent>
        <TabsContent value="dashboards" className="mt-0">
          <AdminHostDashboardsPage />
        </TabsContent>
      </Tabs>
    </div>
  );
}
